export const GRUPOCOMPROBANTEGROUP = {
    FACTURAS_DE_VENTA: { id: 1, codigo: 'FVT', descripcion: 'FACTURAS DE VENTA'},
    COBRO_VENTAS: { id: 9, codigo: 'COVT', descripcion: 'COBROS DE VENTAS', idComprobante: 9},
    COBRO_APORTES: { id: 31, codigo: 'COAP', descripcion: 'COBROS DE APORTES', idComprobante: 41},
    COBRO_CREDITO: { id: 32, codigo: 'COCR', descripcion: 'COBROS DE CREDITO', idComprobante: 42},
    COBRO_MULTAS: { id: 33, codigo: 'COMU', descripcion: 'COBROS DE MULTAS', idComprobante: 43},
    COBRO_CREDITOS: { id: 32, codigo: 'COMU', descripcion: 'COBROS DE CREDITOS', idComprobante: 42},
    CREDITO_A_SOCIO: { id: 14, codigo: 'CRSO', descripcion: 'CREDITO A SOCIO'},
    MULTA_SOCIO: { id: 15, codigo: 'MUSO', descripcion: 'MULTAS A SOCIO'},
    APORTE_SOCIO: { id: 16, codigo: 'APSO', descripcion: 'APORTE DE SOCIO'},
}
